import { useEffect, useState } from "react";
import { Image } from "react-bootstrap"
import { useNavigate } from "react-router-dom";
import { Collapse } from "reactstrap";
import useFieldItem from "../../widgets/fields/UseFieldItem";
import { FieldItem } from "../../widgets/fields";
import { useDispatch, useSelector } from "react-redux";
import { authSelector, setLoading } from "../../store/slices/auth";
import { CustomButton, showToaster, toasterTypes } from "../../widgets";
import { getForms, getGroups, getVariable, postGroupVariable, updateGroupVariable } from "./apiController";
import { getFormRecords } from "../dataCollection/apiController";
import { GroupFormElements } from "./FieldElements";
import AddGroupConditionMobile from "./AddGroupConditionMobile";

const EditGroupingMobile = (props) => {
    const dispatch = useDispatch();
    let componentObj = {};
    const [isOpenCondition, setisOpenCondition] = useState(true)
    const [isOpenGroup, setisOpenGroup] = useState(true)
    const [values, fields, handleChange, { validateValues, reset, updateValue, updateError }] = useFieldItem(GroupFormElements, {}, { onValueChange });
    const [variableList, SetVariableList] = useState<any>([]);
    const [selectedgroupType, SetGroupType] = useState("");
    const [projectData, SetProjectData] = useState<any>([]);
    const [groupData, SetGroup] = useState<any>([]);
    const [variableData, SetvariableData] = useState<any>([]);
    const [itemCount, SetItemCount] = useState(0);
    const [formList, SetFormList] = useState<any>([]);
    const [formvariables, setformVariables] = useState<any>([]);
    const [formAddvariables, setformAddVariables] = useState<any>([]);
    const [formvariablesValue, setformVariablesValue] = useState<any>([]);
    const [isSuggestion, SetSuggestion] = useState(false);
    const [pageSize, SetPageSize] = useState(10);
    const [variables, Setvariables] = useState<any>([])
    const [popupType, SetpopupType] = useState("");
    const [formuladata, Setformuladata] = useState<any>({ display_formula: "", formula: "" });
    const projectDataPerm = useSelector(authSelector)
    const [permissionData, setPermissionData] = useState({});
    const [previousData, SetpreviousData] = useState<any>([]);


    let ComputeOperators = [
        { value: ">", label: ">" },
        { value: "<", label: "<" },
        { value: "==", label: "==" },
        { value: ">=", label: ">=" },
        { value: "<=", label: "<=" },
        { value: "!=", label: "!=" },
        { value: "contains", label: "contains" },
        { value: "and", label: "and" },
        { value: "or", label: "or" },
        { value: "not", label: "not" },
        { value: "in", label: "in" },
        { value: "+", label: "+" },
        { value: "-", label: "-" },
        { value: "*", label: "*" },
        { value: "/", label: "/" },
        { value: "%", label: "%" },
        { value: "(", label: "(" },
        { value: ")", label: ")" },
        { value: "[", label: "[" },
        { value: "]", label: "]" },
        { value: "sqrt", label: "sqrt" },
        { value: "square", label: "square" },
        { value: "cube", label: "cube" },
        { value: "power", label: "power" }
    ]
    // const { variables } = props;
    let Operators = [{ value: ">", label: ">" },
    { value: "<", label: "<" },
    { value: "==", label: "==" },
    { value: ">=", label: ">=" },
    { value: "<=", label: "<=" },
    { value: "!=", label: "!=" },
    { value: "contains", label: "contains" }];

    let LogicalOpt = [{ value: "Select", label: "Select" },
    { value: "and", label: "and" },
    { value: "or", label: "or" }];


    /**
 * fetch group data
 * @param topicId 
 */
    const fetchPreviousGroupData = async (id) => {
        let preDataArray: any = [];
        //SetpopupType("formula")
        try {
            dispatch(setLoading(true));
            let response = await getVariable(id);
            console.log("+++", response)

            SetpreviousData(response);

            let variableDataType = GroupFormElements.variablefieldtype.values.filter(item => item.value == response.field_type)

            let fieldUseTypeData = response?.field_use_type.split(",").map(item => ({ value: item, label: item }));
            console.log(response, fieldUseTypeData, variableDataType)
            let Obj = {
                "grouptype": response.metadata.group_type,
                "newcolumnname": response.field_name,
                "variable": response.metadata.variable,
                "variablefieldtype": variableDataType[0],
                "fieldusetype": fieldUseTypeData
            }

            await updateValue(Obj)

            console.log(Obj)

            if (response.metadata && response.metadata.variable?.type == "radioButton" || response.metadata.variable?.type == "checkBox" || response.metadata.variable?.type == "dropDown") {
                SetGroupType("Categorical")
                await getVariableData(response.metadata.variable.value, "")
            } else {
                SetGroupType("Numeric")
                SetvariableData([])
            }

            if (response.metadata.group_type.value == "Advanced_compute") {
                SetGroupType("compute")
            }

            let keyNum = 0;
            let keyComp = 0;
            if (response.expression[0].expression_type != "formula") {

                let responseVarialbe: any = [];
                if (response.metadata.group_type.value != "Advanced_compute") {
                    responseVarialbe = await getVariable(response.metadata.variable.value);
                }

                keyNum = 0;
                response.expression.map(async (item, index) => {
                    console.log(response,variableData,item)
                    let Itemslength = item.conditions.filter(val => val.key == "field").length;

                    if (response.metadata.group_type && response.metadata.group_type.value == "category_grouping" && response.metadata.variable.type != "textBox") {
                        SetGroupType("Categorical")
                        let componentObjNew = {};
                        componentObjNew['key'] = index + 1;
                        componentObjNew['newcode'] = item.value;
                        componentObjNew['variablelist'] = variableData.field_value;
                        componentObjNew['values'] = item.conditions[0].value.map(itm => ({ label: itm, value: itm }));
                        componentObjNew['opt'] = undefined;
                        componentObjNew['logic'] = undefined;
                        let fieldValues: any = [];
                        responseVarialbe.field_value.map((item, i) => {
                            let Obj = {
                                label: item,
                                value: item
                            }
                            fieldValues.push(Obj)
                        })
                        componentObjNew['field_value'] = fieldValues;

                        SetSuggestion(variableList.length == 0 ? true : false)
                        preDataArray.push(componentObjNew)
                    } else if (response.metadata.group_type && response.metadata.group_type.value == "numericgrouping" || response.metadata.variable && response.metadata.variable.type == "textBox") {
                        SetGroupType("Numerical")
                        item.conditions.filter(val => val.key == "field").map((itemsCondition, j) => {
                            let componentObjNew = {};
                            let optr = ComputeOperators.filter(val => item && itemsCondition.value.replace(/[a-zA-Z0-9.']/g, "") == val.value)
                            let val = itemsCondition && itemsCondition?.value?.split(optr[0].value)[1]
                            if (item.conditions[j + 1] && item.conditions[j + 1].key == "condition") {
                                var logicData =  ComputeOperators.filter(val => val.value == item.conditions[j + 1].value)[0]
                                componentObjNew['logic'] = logicData;
                            }
                            console.log(j+1,item.conditions.filter(val => val.key == "field").length)
                            componentObjNew['key'] = keyNum + 1;
                            componentObjNew['newcode'] = j+1 == Itemslength ? item.value : "";
                            componentObjNew['variablelist'] = [];
                            componentObjNew['field_use_type'] = response.metadata.variable.type;
                            componentObjNew['values'] = response.metadata.variable;
                            componentObjNew['opt'] = optr[0];
                            componentObjNew['val'] = val.replaceAll(`'`,'');
                            let fieldValues: any = [];
                            responseVarialbe.field_value.map((item, i) => {
                                let Obj = {
                                    label: item,
                                    value: item
                                }
                                fieldValues.push(Obj)
                            })
                            componentObjNew['field_value'] = fieldValues;
                            // SetSuggestion(variableList.length == 0 ? true : false)
                            console.log(componentObjNew)
                            preDataArray.push(componentObjNew)
                            keyNum = keyNum + 1;
                        })
                    } else {
                        console.log(item)
                        item.conditions.filter(val => val.key == "field").map(async (itemsCondition, j) => {
                            let componentObjNew = {};
                            console.log(itemsCondition)
                            let optr = typeof itemsCondition.value == "string" && ComputeOperators.filter(val => item && itemsCondition.value.replaceAll(/[a-zA-Z0-9.']/g, "") == val.value)
                            console.log(response,item)
                            let val = typeof itemsCondition.value == "string" ? itemsCondition && itemsCondition?.value?.split(optr[0].value)[1] : itemsCondition?.value
                            if (item.conditions[j + 1] && item.conditions[j + 1].key == "condition") {
                                var logicData =  ComputeOperators.filter(val => val.value == item.conditions[j + 1].value)[0]
                                componentObjNew['logic'] = logicData;
                            }
                            let fieldValuesData: any = [];
                            let tempId = response.metadata.variable[j].id
                            if(response.metadata.variable[j].type == "radioButton"){
                                let response = await getVariable(tempId);
                                    response.field_value.map((item, i) => {
                                        let Obj = {
                                            label: item,
                                            value: item
                                        }
                                        fieldValuesData.push(Obj)
                                    })
                            }
                            componentObjNew['key'] = keyNum + 1;
                            componentObjNew['newcode'] = j+1 == Itemslength ? item.value : "";
                            componentObjNew['variablelist'] = fieldValuesData;
                            componentObjNew['field_use_type'] = "";
                            componentObjNew['values'] = response.metadata.variable[j];
                            componentObjNew['opt'] = optr[0];
                            componentObjNew['val'] = typeof itemsCondition.value == "string" ? response.metadata.variable[j].type == "radioButton" ? {label:val.replaceAll(`'`,''),value:val.replaceAll(`'`,'')} : val.replaceAll(`'`,'') : itemsCondition.value.map(itm => ({label:itm,value:itm}));
                            let fieldValues: any = [];
                            componentObjNew['field_value'] = fieldValues;
                            //SetSuggestion(variableList.length == 0 ? true : false)
                            console.log(componentObjNew)
                            preDataArray.push(componentObjNew)
                            keyNum = keyNum + 1;
                        })
                    }
                })
                console.log('preDataArray', preDataArray, response)
                let tempObject = [
                    {
                        "variablelist": preDataArray,
                        "OriginalVal": {
                            "isOriginal": response.default_value.includes("original_value") ? "original":"custom",
                            "customVal": response.default_value.includes("original_value") ? "" : response.default_value
                        }
                    }
                ]
                console.log(tempObject)
                SetVariableList(tempObject)
                fetchFormVariables(response.metadata.group_type.label);

            } else {
                let preDataArray: any = [];
                response.expression.map(async (item, index) => {
                    let componentObjNew = {};
                    componentObjNew['key'] = index + 1;
                    componentObjNew['newcode'] = item.display_formula;
                    componentObjNew['variablelist'] = [];
                    componentObjNew['field_use_type'] = "";
                    let fieldValues: any = [];
                    componentObjNew['field_value'] = fieldValues;
                    preDataArray.push(componentObjNew)

                })
                console.log(preDataArray)
                SetpopupType('formula')
                SetVariableList(preDataArray)
            }

            dispatch(setLoading(false));



        } catch (e: any) {

        }

    }

    useEffect(() => {
        console.log(props)
        let perData = projectDataPerm.projectPermissionData?.filter(itm => itm.projectId == props.projectData.id)
        let permArray = {};
        perData && perData[0]?.permissionData.forEach((obj) => {
            if (Object.keys(obj)[0] == "Data") {
                obj[Object.keys(obj)[0]].forEach((objItem) => {
                    permArray[objItem.action] = objItem.permissions.filter(itemflt => itemflt.title == "allowed")[0]?.is_selected
                })
                //setPermission(obj[Object.keys(obj)[0]])
            } else if (Object.keys(obj)[0] == "Forms") {
                obj[Object.keys(obj)[0]].forEach((objItem) => {
                    permArray[objItem.action] = objItem.permissions.filter(itemflt => itemflt.title == "allowed")[0]?.is_selected
                })
            }
        })
        setPermissionData(permArray)
        fetchColumns(permArray && permArray['all data view']);
        SetProjectData(props.data)
        fetchGroups(props.data.TopicID)
        fetchFormVariables("");
        fetchPreviousGroupData(props.selectedData.id)

    }, [])

    useEffect(() => {

    }, [popupType])

    /**
    * on value change update form data
    * @param name 
    * @param value 
    * @param values 
    * @param fieldValues 
    * @returns 
    */
    function onValueChange(name, value, values, fieldValues = null) {
        let resetValue = {};
        console.log(value)
        if (name == "grouptype") {
            fetchFormVariables(value.label);
            SetGroupType(value.label)
            SetVariableList([])
            SetpopupType("")
            values.variable = {}
            values.newcolumnname = [];
            values = [];
        } else if (name == "variable") {
            SetItemCount(0);
            SetVariableList([]);
            SetItemCount(itemCount + 1);
            values.newcolumnname = [];
            if (value.type == "radioButton" || value.type == "checkBox") {
                SetGroupType("Categorical")
                console.log(value)
                getVariableData(value.value, "")
            } else {
                SetGroupType("Numeric")
                SetvariableData([])
            }
            let componentObj = formvariablesValue.filter(item => item.field_name == value.label);
            SetVariableList(componentObj)
            console.log(componentObj)
        }

        return [{
            ...values,
            ...resetValue,
            [name]: value,
        }]
    }


    /**
    * get variable data for selected variable 
    * @param id 
    */
    const getVariableData = async (id, key) => {
        try {
            let response = await getVariable(id);
            SetvariableData(response)
            console.log(response)
        } catch (e: any) {

        }
    }
    /**
     * get variables data
     * @param formData 
     */
    const fetchFormVariables = async (groupdata) => {
        try {
            setformVariables([]);
            setformVariablesValue(variables);
            if (groupdata == "Categorical") {
                variables.filter(itemfield => itemfield.field_type == "radioButton" || itemfield.field_type == "checkBox").map((item, i) => {
                    let Obj = {
                        label: item.label,
                        value: item.id,
                        type: item.field_type
                    }
                    setformVariables(prevState => [...prevState, Obj]);
                })
            } else if (groupdata == "Numerical") {
                variables.filter(itemfield => itemfield.field_type == "number").map((item, i) => {
                    let Obj = {
                        label: item.label,
                        value: item.id,
                        type: item.field_type
                    }
                    setformVariables(prevState => [...prevState, Obj]);
                })
            } else if (groupdata == "Compute") {
                variables.map((item, i) => {
                    let Obj = {
                        label: item.label,
                        value: item.id,
                        type: item.field_type
                    }
                    let ObjAdd = {
                        label: item.label,
                        value: item.label,
                        id: item.id,
                        type: item.field_type
                    }
                    setformVariables(prevState => [...prevState, Obj]);
                    setformAddVariables(prevState => [...prevState, ObjAdd]);
                })
            }

        } catch (e: any) {
            setformVariables([]);
        }
    }

    /**
     * get variable list
     */
    const fetchColumns = async (checkAll) => {
        try {
            dispatch(setLoading(true));
            let response = await getFormRecords(props?.formData.id, 1, pageSize, checkAll);
            if (response.data && response.data.length > 0) {
                let tempHeaders: any = [];
                response.data.forEach((obj, index) => {
                    obj.fields.forEach(subObj => {
                        if (index > 0) {
                            let check = tempHeaders.filter(elem => elem.value === subObj.id);
                            if (check.length === 0) {
                                tempHeaders.push({
                                    label: subObj.field_name,
                                    value: subObj.id,
                                    data: subObj,
                                    type: subObj.field_type
                                });
                            }
                        } else {
                            tempHeaders.push({
                                label: subObj.field_name,
                                value: subObj.id,
                                data: subObj,
                                type: subObj.field_type
                            });
                        }
                    });
                });
                console.log(tempHeaders)

                let tempColumns: any = [];
                tempHeaders.forEach(obj => {
                    tempColumns.push({
                        "id": obj.value,
                        "label": obj.label,
                        accessor: elem => (obj.data.field_type === 'fileUpload' && elem[obj.value]) ? <div className='link-text' onClick={() => window.open(elem[obj.value])}>Link</div> : elem[obj.value]?.toString() || '-',
                        "sort": "asc",
                        "field_type": obj.type
                    })
                })

                Setvariables(tempColumns);
            }
            dispatch(setLoading(false));
        } catch (e: any) {
            dispatch(setLoading(false));
        }
    };


    /**
     * get groups
     * @param id 
     */
    const fetchGroups = async (id) => {
        try {
            dispatch(setLoading(true));
            let tempGroups = await getGroups(id);
            SetGroup(tempGroups?.data || []);
            fetchForms(tempGroups?.data[0].id);
            dispatch(setLoading(false));
        } catch (e: any) {
            SetGroup([]);
            dispatch(setLoading(false));
        }
    };

    /**
     * fetch form list
     * @param index 
     * @param id 
     */
    const fetchForms = async (id) => {
        try {
            dispatch(setLoading(true));
            let tempForms = await getForms(id);
            SetFormList([]);
            tempForms.map((item, i) => {
                let Obj = {
                    label: item.form_name,
                    value: item.id
                }
                SetFormList(prevState => [...prevState, Obj]);
            })
            SetSuggestion(true)
            dispatch(setLoading(false));
        } catch (e: any) {
            dispatch(setLoading(false));
        }
    };

    /**
     * @param data get data from addgroups component call back
     */
    const getData = (data) => {
        console.log(data)
        SetVariableList(data)
        setisOpenGroup(false)
    }
    /**
     * recreate the array of items for submissions
     * call to API
     */
    const saveData = async () => {
        console.log(variableList[0])
        let regroupfields: any = [];
        if (selectedgroupType == "Categorical") {
            variableList[0].variablelist.map((item, index) => {
                let oldCodesVal: any = [];
                let condition: any = [];
                item.values.map(items => {
                    console.log(items)
                    oldCodesVal.push(items.label)
                })
                console.log(item)
                //newCode: values["newcode" + item.key],
                condition.push({
                    "key": "field",
                    "field_id": item.fieldid,
                    "value_type": "list",
                    "value": oldCodesVal,
                    "display_value": values.variable.label + " Contains " + oldCodesVal
                })

                regroupfields.push({
                    expression_type: "condition",
                    "conditions": condition,
                    value: item["newcode"]
                })
            })
        } else if (selectedgroupType == "Numerical") {
            let condition: any = [];
            let valueField = "";
            console.log(values)
            variableList[0].variablelist.map((item, index) => {
                condition.push({
                    "key": "field",
                    "field_id": item.values.value,
                    "value_type": "expression",
                    "display_value": item.values.label + item.opt.value + item.val,
                    "value": "x" + item.opt.value + item.val
                })

                if (!item.newcode && item.logic?.value != "Select" && item.logic) {
                    condition.push({
                        "key": "condition",
                        "value_type": "logical_operator",
                        "value": item.logic.value
                    })
                }
                valueField = item.newcode

                if (item.newcode) {
                    regroupfields.push({
                        expression_type: "condition",
                        "conditions": condition,
                        value: valueField
                    })

                    condition = []
                }
            })
        } else {
            let condition: any = [];
            let valueField = "";
            variableList[0].variablelist.map((item, index) => {
                console.log(item)
                if (item.opt?.value == "contains") {
                    let oldCodesVal: any = [];
                    if (typeof (item.val) == "object") {
                        item.val.map(items => {
                            console.log(items)
                            oldCodesVal.push(items.label)
                        })
                    }
                    console.log(item)


                    condition.push({
                        "key": "field",
                        "field_id": item.values?.id,
                        "value_type": "list",
                        "display_value": typeof (item.val) == "object" ? item.values?.label + " contains " + oldCodesVal : item.values.label + " Contains " + item.val,
                        "value": typeof (item.val) == "object" ? oldCodesVal : item.val
                    })
                } else {
                    let valuesData = "";
                    let displayData = "";
                    console.log(item)
                    if (item.values?.type == "radioButton" || item.values?.type == "checkBox") {
                        valuesData = `'x'` + item.opt?.value + `'` + item.val.map(it => it.label) + `'`
                        displayData = item.values?.label + item.opt?.value + `'` + item.val.map(it => it.label) + `'`
                    } else {
                        valuesData = item.val;
                        if (item.values.type != "number") {
                            valuesData = `'x'` + item.opt?.value + `'` + valuesData + `'`
                            displayData = item.values?.label + item.opt?.value + item.val
                        } else {
                            valuesData = 'x' + item.opt?.value + item.val
                            displayData = item.values?.label + `'` + item.val + `'`
                        }
                    }
                    condition.push({
                        "key": "field",
                        "field_id": item.values?.id,
                        "value_type": "expression",
                        "value": valuesData,
                        "display_value": displayData
                    })
                }

                if (!item.newcode && item.logic?.value != "Select" && item.logic) {
                    condition.push({
                        "key": "condition",
                        "value_type": "logical_operator",
                        "value": item.logic.value
                    })
                }

                valueField = item.newcode;

                if (item.newcode) {
                    regroupfields.push({
                        expression_type: "condition",
                        "conditions": condition,
                        value: valueField
                    })
                    condition = []
                }
            })
            // regroupfields.push({
            //     "conditions": condition,
            //     value: valueField
            // })
        }

        let topicId = props.data.TopicID;

        let finalObj = {
            "id": props.selectedData.id,
            "topic_id": topicId,
            "form_id": previousData.form_id,
            "user_number": previousData.user_number,
            "field_name": values.newcolumnname || "",
            "field_description": values.newcolumnname,
            "field_type": values.variablefieldtype.value,
            "field_use_type": values.fieldusetype.map(item => item.value).join(","),
            "expression": regroupfields,
            "field_visibility": previousData.field_visibility,
            "metadata": previousData.metadata,
            "default_value": variableList[0]?.OriginalVal.isOriginal == "custom" ? variableList[0].OriginalVal.customVal : "$$original_value$$"
        }
        console.log(variableList[0])
        console.log(finalObj)

        // try {
        //     dispatch(setLoading(true));
        //     let submitResponse = await updateGroupVariable(finalObj);
        //     if (submitResponse) {
        //         showToaster(toasterTypes.SUCCESS, "Variable created Successfully")
        //         dispatch(setLoading(false));
        //         props.onClose();
        //     }
        // } catch (e: any) {
        //     console.log(e)
        //     dispatch(setLoading(false));
        // }

    }


    /**
     * onclose popup
     */
    const onClose = () => {
        SetpopupType("")
        Setformuladata({})
    }


    useEffect(() => {

    }, [variableData, variableList, isOpenGroup])

    return (
        <>
            {
                popupType == "condition" ?
                    <AddGroupConditionMobile
                        {...props}
                        onClose={onClose}
                        variablelist={variableData}
                        getData={getData}
                        selectedGroup={selectedgroupType}
                        previousData={variableList}
                        groupDetails={values}
                        formvariables={formAddvariables} />
                    :
                    <div className="add-grouping-mobile">
                        <div className="header-container">
                            <div className=' pl-3 pt-4 closeicon'>
                                <i className='icon icon-back_arrow' onClick={() => props.onBack()} />
                            </div>
                            <div className='pl-1 pt-4 form-name'>
                                <Image className='profile-image' alt='Profile' src={`${process.env.PUBLIC_URL}/images/logo.png`} />
                                Configure Group
                            </div>

                        </div>
                        <div className="grouping-details" onClick={() => setisOpenGroup(!isOpenGroup)}>
                            <div className="group pt-3">Grouping Details</div>
                            <div className="group-arrow pt-2">
                                {isOpenGroup ?
                                    <i className="icon icon-arrow_up" onClick={() => setisOpenGroup(false)}></i>
                                    :
                                    <i className="icon icon-arrow_down" onClick={() => setisOpenGroup(true)}></i>
                                }
                            </div>
                        </div>
                        <Collapse isOpen={isOpenGroup} className="group-form-items">
                            <div className="group-form">
                                <FieldItem
                                    {...GroupFormElements.grouptype}
                                    value={values.grouptype}
                                    values={GroupFormElements.grouptype.values}
                                    onChange={(...e) => handleChange(GroupFormElements.grouptype.name, ...e)}
                                    touched={fields.grouptype && fields.grouptype.hasError}
                                    error={fields.grouptype && fields.grouptype.errorMsg}
                                />
                                {values && values.grouptype?.value != "Advanced_compute" ?
                                    <>
                                        <FieldItem
                                            {...GroupFormElements.variable}
                                            value={values.variable}
                                            values={formvariables}
                                            isMandatory={selectedgroupType == "Compute" ? false : true}
                                            onChange={(...e) => handleChange(GroupFormElements.variable.name, ...e)}
                                            touched={fields.variable && fields.variable.hasError}
                                            error={fields.variable && fields.variable.errorMsg}
                                        />
                                    </>
                                    : ""}

                                <FieldItem
                                    {...GroupFormElements.newcolumnname}
                                    value={values.newcolumnname}
                                    onChange={(...e) => handleChange(GroupFormElements.newcolumnname.name, ...e)}
                                    touched={fields.newcolumnname && fields.newcolumnname.hasError}
                                    error={fields.newcolumnname && fields.newcolumnname.errorMsg}
                                />

                                <FieldItem
                                    {...GroupFormElements.variablefieldtype}
                                    value={values.variablefieldtype}
                                    onChange={(...e) => handleChange(GroupFormElements.variablefieldtype.name, ...e)}
                                    touched={fields.variablefieldtype && fields.variablefieldtype.hasError}
                                    error={fields.variablefieldtype && fields.variablefieldtype.errorMsg}
                                />

                                <FieldItem
                                    {...GroupFormElements.fieldusetype}
                                    value={values.fieldusetype}
                                    onChange={(...e) => handleChange(GroupFormElements.fieldusetype.name, ...e)}
                                    touched={fields.fieldusetype && fields.fieldusetype.hasError}
                                    error={fields.fieldusetype && fields.fieldusetype.errorMsg}
                                />
                            </div>
                        </Collapse>
                        <div className="grouping-details" onClick={() => setisOpenCondition(!isOpenCondition)}>
                            <div className="group pt-3">Conditions</div>
                            <div className="group-arrow pt-2">
                                {isOpenCondition ?
                                    <i className="icon icon-arrow_up" onClick={() => setisOpenCondition(false)}></i>
                                    :
                                    <i className="icon icon-arrow_down" onClick={() => setisOpenCondition(true)}></i>
                                }
                            </div>
                        </div>
                        <Collapse isOpen={isOpenCondition} className="condition-collapse">
                            <div className={variableList && variableList.length > 0 ? "conditions" : "condtionempty"}>
                                {
                                    variableList && variableList.length > 0 &&
                                    <div className="add-details">
                                        <div className="group pt-3"></div>
                                        <div className="group-add pt-3 pr-2" onClick={() => { SetpopupType("condition"); }}>
                                            <i className="icon icon-add" ></i>
                                            Add/Update
                                        </div>
                                    </div>
                                }

                                {
                                    variableList && variableList.length > 0 ?
                                        <><div className="variable-list mt-1 pt-2">
                                            {
                                                variableList[0].variablelist.map((items, index) => {
                                                    return <>
                                                        <div className="variable-item" key={index}>
                                                            <h6>Condition{index + 1}</h6>
                                                            <div className="values-container">
                                                                <span className="label">Values</span>
                                                                <div className="values">
                                                                    {
                                                                        selectedgroupType == "Categorical" &&
                                                                        Array.isArray(items.values) && items.values.map(fieldval => {
                                                                            return <span className="label-value pl-2 pr-2"> {fieldval.label}</span>
                                                                        })
                                                                    }
                                                                    {
                                                                        selectedgroupType == "Numerical" &&
                                                                        <><span className="label-value pl-2 pr-2"> {items.values?.label + items.opt?.value + items.val}</span>
                                                                            {items.logic && items.logic.value != "Select" ? <span className="label-value pl-2 pr-2"> {" " + items.logic.value}</span> : ""}
                                                                        </>
                                                                    }
                                                                    {
                                                                        selectedgroupType == "compute" &&
                                                                        <><span className="label-value pl-2 pr-2"> {items.values?.label + items.opt?.value + (typeof items.val == "string" ? items.val : items.val.map(it => it.label).join(','))}</span>
                                                                            {items.logic && items.logic.value != "Select" ? <span className="label-value pl-2 pr-2"> {" " + items.logic.value}</span> : ""}
                                                                        </>
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="newcode-container">
                                                                {
                                                                    items.newcode &&
                                                                    <><span className="label">New code/value</span>
                                                                        <div className="values">
                                                                            <span> {items.newcode}</span>
                                                                        </div></>
                                                                }

                                                            </div>
                                                        </div>
                                                    </>
                                                })
                                            }
                                            {
                                                <div className="variable-item">
                                                    <h6>Default Condition</h6>
                                                    <div className="newcode-container">
                                                        <span className="label">Default value</span>
                                                        <div className="values">
                                                            <span> {variableList && variableList[0]?.OriginalVal.isOriginal == "custom" ? variableList[0].OriginalVal.customVal : "Original Value"}</span>
                                                        </div>
                                                    </div>


                                                </div>
                                            }
                                        </div>
                                        </>
                                        :
                                        <div className="no-items">
                                            <p>Start adding conditions</p>
                                            <div className="condition-buttons">
                                                {
                                                    values.grouptype && values.grouptype.label == "Compute" &&
                                                    <CustomButton className="create-btn" type={"alert-primary"} text="Add Formula" onClick={() => { SetpopupType("condition"); }}></CustomButton>
                                                }
                                                <CustomButton
                                                    className="create-btn"
                                                    type={"alert-primary"}
                                                    text="Add Condition"
                                                    onClick={() => { SetpopupType("condition"); }}
                                                    isDisabled={values.grouptype && values.variable || values.grouptype && values.grouptype.label == "Compute" ? false : true}
                                                ></CustomButton>
                                            </div>
                                        </div>
                                }
                                {
                                    variableList && variableList.length > 0 &&
                                    <div className="submit-btn">
                                        <CustomButton className="create-btn" type={"alert-primary"} text="Submit" onClick={() => { saveData() }}></CustomButton>
                                    </div>
                                }

                            </div>
                        </Collapse>

                    </div>
            }
        </>
    )
}

export default EditGroupingMobile;